import React from 'react';

import bottomViewDrone from '../../../main/assets/images/mrm1-5/full-view-propeller.webp';

export const Specifications = () => {
  return (
    <section className="mrm2-system-section">
      <div className="mrm2-system-product-container">
        <h2 className="mrm2-system-title">SYSTEM PARAMETERS</h2>
        <div className="mrm1-system-product-wrapper">
          <img
            src={bottomViewDrone}
            alt="Representation of the Tactical System"
            className="mrm1-system-product"
          />
        </div>
      </div>
      <div className="mrm2-system-specs-column">
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">Motors and Propellers</h3>
          <p className="mrm2-system-specs-description">ORQA 2408 / 2200 kV</p>
          <p className="mrm2-system-specs-description">5-inch propellers</p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">CAMERA</h3>
          <p className="mrm2-system-specs-description">
            ORQA Justice FPV camera
          </p>
          <p className="mrm2-system-specs-description">
            4:3 / 16:9 switchable aspect ratio
          </p>
          <p className="mrm2-system-specs-description">
            1200TVL (suitable for low light)
          </p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">RC Link</h3>
          <p className="mrm2-system-specs-description">
            Available in two variants:
          </p>
          <p className="mrm2-system-specs-description">
            EW-resilient Dual Sub-GHz IRONghost
          </p>
          <p className="mrm2-system-specs-description">
            ISM 2.4 GHz Ghost Protocol
          </p>
        </div>
      </div>
      <div className="mrm2-system-specs-column">
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">ESc</h3>
          <p className="mrm2-system-specs-description">ORQA 60A 4-in-1</p>
          <p className="mrm2-system-specs-description">30x30 60A ESC</p>
          <p className="mrm2-system-specs-description">
            Pre-flashed with AM32 firmware
          </p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">Flight Controller</h3>
          <p className="mrm2-system-specs-description">ORQA F405</p>
          <p className="mrm2-system-specs-description">30x30 F405 FC</p>
          <p className="mrm2-system-specs-description">
            Ardupilot, iNav & Betaflight support
          </p>
          <p className="mrm2-system-specs-description">
            MAVLINK support & ATAK integration
          </p>
          <p className="mrm2-system-specs-description">GPS included</p>
        </div>
        <div className="mrm2-system-specs-container">
          <h3 className="mrm2-system-specs-title">Video Transmission</h3>
          <p className="mrm2-system-specs-description">
            5.8 GHz Analog Video Transmitter
          </p>
          <p className="mrm2-system-specs-description">
            Operates on ISM 5.8 GHz band
          </p>
        </div>
      </div>
    </section>
  );
};
